import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const ukTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: "Ім'я (малі літери, без спеціальних символів)",
    add: 'додати',
    allowedFileTypes: 'Дозволені типи файлів',
    allowedFileTypesDescription:
      'Обмежити дозволені типи файлів (наприклад, зображення/*, додаток/pdf). Залиште пустим, щоб дозволити всі типи.',
    allowMultipleFiles: 'Дозволити кілька файлів',
    amountInCents: 'Сума в центах',
    basePrice: 'Базова ціна',
    bcc: 'BCC',
    brand: 'Бренд',
    cc: 'CC',
    checkboxPlural: 'Поля прапорця',
    checkboxSingular: 'Прапорець',
    checkedByDefault: 'Позначено за замовчуванням',
    chooseConfirmationType:
      'Виберіть, чи відображати повідомлення на сторінці чи перенаправляти на іншу сторінку після надсилання форми.',
    condition: 'Стан',
    confirmationMessage: 'Повідомлення підтвердження',
    confirmationType: 'Тип підтвердження',
    countryPlural: 'Country Fields',
    countrySingular: 'Країна',
    creditCard: 'Кредитна картка',
    customURL: 'Спеціальна URL-адреса',
    datePlural: 'Поля дати',
    dateSingular: 'Дата',
    defaultValue: 'Значення за замовчуванням',
    divide: 'Розділити',
    documentToLinkTo: 'Документ для посилання',
    doesNotEqual: 'Не дорівнює',
    emailFrom: 'Електронна пошта від',
    emailPlural: 'Поля електронної пошти',
    emailsDescription:
      'Надсилайте персоналізовані електронні листи після надсилання форми. Використовуйте списки, розділені комами, щоб надіслати той самий електронний лист кільком одержувачам. Щоб посилатися на значення з цієї форми, візьміть назву цього поля в подвійні фігурні дужки, тобто {{firstName}}. Ви можете використовувати символ підстановки {{*}}, щоб вивести всі дані, і {{*:table}}, щоб відформатувати їх як HTML-таблицю в електронному листі.',
    emailSingular: 'Електронна пошта',
    emailTo: 'Електронна пошта до',
    equals: 'Дорівнює',
    field: 'Поле',
    fields: 'поля',
    fieldWidth: 'Ширина поля (у відсотках)',
    hasAnyValue: 'Має будь-яку цінність',
    internalLink: 'Внутрішнє посилання',
    label: 'Мітка',
    maxFileSize: 'Максимальний розмір файлу (байти)',
    maxFileSizeDescription:
      'Максимальний розмір файлу в байтах. Залиште порожнім, щоб не було обмежень.',
    message: 'повідомлення',
    messageDescription: 'Введіть повідомлення, яке потрібно надіслати в цьому електронному листі.',
    messagePlural: 'Блоки повідомлень',
    messageSingular: 'повідомлення',
    mimeType: 'Тип MIME',
    mimeTypePlural: 'Типи MIME',
    mimeTypeSingular: 'Тип MIME',
    multiply: 'Помножити',
    numberPlural: 'Числові поля',
    numberSingular: 'Номер',
    optionPlural: 'Опції',
    optionSingular: 'Варіант',
    paymentFieldPlural: 'Поля оплати',
    paymentFieldSingular: 'Оплата',
    paymentProcessor: 'Процесор платежів',
    paymentStatus: 'Статус',
    placeholder: 'Заповнювач',
    priceConditions: 'Цінові умови',
    priceConditionsPlural: 'Цінові умови',
    priceConditionsSingular: 'Умова ціни',
    radioOptions: 'Параметри атрибутів радіо',
    radioPlural: 'Радіо Поля',
    radioSingular: 'радіо',
    redirect: 'Перенаправлення',
    replyTo: 'Відповісти',
    required: "Обов'язковий",
    selectOptions: 'Виберіть Параметри',
    selectPlural: 'Виберіть Поля',
    selectSingular: 'Виберіть',
    statePlural: 'Державні поля',
    stateSingular: 'Держава',
    staticValue: 'Статичне значення',
    subject: 'Тема',
    submitButton: 'Надіслати мітку кнопки',
    subtract: 'Відняти',
    textareaPlural: 'Поля Textarea',
    textareaSingular: 'Текстове поле',
    textPlural: 'Текстові поля',
    textSingular: 'текст',
    title: 'Назва',
    token: 'жетон',
    uploadCollection: 'Завантажити колекцію',
    uploadCollectionDescription: 'Виберіть, у якій колекції завантажень зберігати файли',
    uploadFieldPlural: 'Поля завантаження',
    uploadFieldSingular: 'Завантажити',
    urlToRedirectTo: 'URL-адреса для перенаправлення',
    value: 'Значення',
    valueOfField: 'Значення поля',
    valueType: 'Тип значення',
  },
}

export const uk: PluginLanguage = {
  dateFNSKey: 'uk',
  translations: ukTranslations,
}
